export default defineComponent({
  props: {
    divideX: {
      type: Boolean,
      default: false
    }
  }
});